import React, {useEffect, useState} from 'react';

import {Link, useParams} from "react-router-dom";

import {useDispatch, useSelector} from "react-redux";

import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import ArrowBackIcon from "@material-ui/icons/ArrowBack.js";
import {makeStyles} from "@material-ui/styles";
import Typography from "@material-ui/core/Typography";

import {RouteNames} from "../../router/consts.js";
import {getCompaniesNodes, selectContracts, selectProjects} from "../../redux/reducers/projects-edit-reducer.js";

import {CommonLayout} from "../../layouts/CommonLayout/CommonLayout";
import {Tabs} from "../../components/Tabs/Tabs";
import {ActTemplateEdit} from "../../containers/ActTemplateEdit/ActTemplateEdit";
import HandbookEditContainer from "../../containers/HandbookEditContainer/HandbookEditContainer.jsx";
import {TableTemplateEdit} from "../../containers/TableTemplateEdit/TableTemplateEdit";
import WordTemplateUploadContainer from "../../containers/WordTemplateUploadContainer/WordTemplateUploadContainer.jsx";
import { getProfile } from '../../redux/reducers/user-profile-reducer.js';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { setSelectedProject } from '../../redux/reducers/project-reducer.js';
import { setSelectedContract } from '../../redux/reducers/contract-reducer.js';
import ExcelTemplateUploadContainer from '../../containers/ExcelTemplateUploadContainer/ExcelTemplateUploadContainer.jsx';


const useStyles = makeStyles((theme) => ({
    contentContainer: {
        height: '100%'
    },
    paper: {
        width: '100%',
        height: 'calc(100vh - 180px)',
    },
    header: {
        paddingBottom: theme.spacing(1)
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
    },
}))


const tabsConfig = [
    {value: 'act-template', label: 'Шаблон акта', component: 
        <DndProvider backend={HTML5Backend}>
            <ActTemplateEdit />
        </DndProvider> 
    },
    
    {value: 'handbook', label: 'Справочник', component: <HandbookEditContainer/>},
    {value: 'excel-template', label: 'Шаблон Excel', component: <ExcelTemplateUploadContainer/>},
    {value: 'word-template', label: 'Шаблон Word', component: <WordTemplateUploadContainer/>},
    {value: 'table-template', label: 'Шаблон главной таблицы', component: <TableTemplateEdit/>},
]

const tabsConfigForSafetyEngineer = [
    {value: 'handbook', label: 'Справочник', component: <HandbookEditContainer/>},
]


const WhichUser = (user) => {
    if (user?.role === 'safety_engineer' || user?.role === 'project_manager') return tabsConfigForSafetyEngineer

    return tabsConfig
}

const ProjectEditPage = () => {
    const {projectID} = useParams()
    const {user} = useSelector(getProfile);

    const classes = useStyles()

    const dispatch = useDispatch()

    const projects = useSelector(selectProjects)
    const contracts = useSelector(selectContracts)

    const [header, setHeader] = useState('')

    useEffect(() => {
        if (projects.length === 0) {
            dispatch(getCompaniesNodes())
        }
    }, [dispatch, projects])

    useEffect(() => {
        if (projects.length > 0 && contracts.length > 0) {
            const project = projects.find(project => project.id === parseInt(projectID))
            const contract = contracts.find(contract => contract.id === project.contract)
            setHeader(`${project.name} - ${contract.name}`)
            dispatch(setSelectedContract({
                company: contract.company,
                id: contract.id,
                name: contract.name,
                update_date: contract.update_date,
            }))
            dispatch(setSelectedProject({
                contract: project.contract,
                id: project.id,
                name: project.name,
                update_date: project.update_date,
            }))
        }
    }, [dispatch, projects, contracts, projectID])

    return (
        <CommonLayout>
            <Grid container direction={'column'} className={classes.contentContainer} wrap={"nowrap"}>
                <Grid container item alignItems={"center"}>
                    <Grid item>
                        <IconButton size={'small'} component={Link}
                                    to={RouteNames.PROJECTS}><ArrowBackIcon/></IconButton>
                    </Grid>
                    <Grid item>
                        <Typography variant={'h5'}>
                            {header}
                        </Typography>
                    </Grid>
                </Grid>
                <Tabs tabs={WhichUser(user)}/>
            </Grid>
        </CommonLayout>
    );
};

export default ProjectEditPage;